const DEFAULT_CREDIT_COST = 1;

function hasEnoughCredits(creditsRemaining, creditCost) {
  return (
    typeof creditsRemaining === 'number' && creditsRemaining >= creditCost
  );
}

export default function canSubmitProjectFromLedger({
  isUnlimited,
  creditType,
  selectedTeamId,
  financeBalance,
  creditCost = DEFAULT_CREDIT_COST,
  teamAgnostic = false
}) {
  if (isUnlimited) {
    return true;
  }

  // Fail-closed: never allow creation against an unknown ledger balance.
  if (!financeBalance) {
    return false;
  }

  if (creditType === 'TEAM') {
    const teamBalances = financeBalance.teamBalances || [];

    // Create gate: open if the pool or any team can cover the cost. Submit
    // still requires a selected team (the per-team branch below).
    if (teamAgnostic) {
      return (
        hasEnoughCredits(financeBalance.poolRemaining, creditCost) ||
        teamBalances.some((team) =>
          hasEnoughCredits(team.creditsRemaining, creditCost)
        )
      );
    }

    const teamBalance = teamBalances.find(
      (team) => team.teamId === selectedTeamId
    );

    // Per ADR-0012 / QA #77: finance keeps no team roster.  A team that has
    // no ledger entry is treated as ZERO balance (disabled gate), never as an
    // error or "not in ledger" state.  This is intentionally different from
    // the fetch-error path above, where financeBalance is null and we fail
    // closed without knowing the true balance.
    const effectiveCreditsRemaining = teamBalance
      ? teamBalance.creditsRemaining
      : 0;

    return hasEnoughCredits(effectiveCreditsRemaining, creditCost);
  }

  return hasEnoughCredits(financeBalance.totalRemaining, creditCost);
}
